import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const ViewFeeExpenseModalContainer = styled.div`
  .container-box {
    width: 100%;
    padding-top: 20px;
  }
  .container-header {
    margin-left: 16px;
  }
  .general-info {
    margin-top: 10px;
  }
  .configuration-container {
    padding: 16px 16px 20px 16px;
  }
  .border-bottom-line {
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }
`;
